import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=18776a29&"
import script from "./setupHome.js?vue&type=script&lang=javascript&"
export * from "./setupHome.js?vue&type=script&lang=javascript&"
import style0 from "./Home.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports